import React from "react";
import { MessageCircle } from "lucide-react";

import { cn } from "../../lib/utils";
import { Button } from "../ui/button";

interface Props {
  href: string;
  disabled?: boolean;
  className?: string;
  children: React.ReactNode;
}

export default function WhatsAppButton({ href, disabled, className, children }: Props) {
  return (
    <Button
      asChild={!disabled}
      disabled={disabled}
      className={cn(
        "h-12 w-full rounded-xl bg-emerald-500 text-base font-semibold text-white shadow-lg shadow-emerald-500/20 hover:bg-emerald-400",
        className
      )}
    >
      {disabled ? (
        <span className="inline-flex items-center gap-2">
          <MessageCircle className="h-5 w-5" /> {children}
        </span>
      ) : (
        <a href={href} target="_blank" rel="noreferrer">
          <MessageCircle className="h-5 w-5" /> {children}
        </a>
      )}
    </Button>
  );
}
